import React, { useEffect, useState } from "react";

// chakra imports
import {
  Box,
  Flex,
  Drawer,
  DrawerBody,
  Icon,
  useColorModeValue,
  DrawerOverlay,
  useDisclosure,
  DrawerContent,
  DrawerCloseButton,
} from "@chakra-ui/react";
import Content from "./Content";
import {
  renderThumb,
  renderTrack,
  renderView,
} from "common/components/scrollbar/Scrollbar";
import { Scrollbars } from "react-custom-scrollbars-2";
import PropTypes from "prop-types";

// Assets
import { IoMenuOutline } from "react-icons/io5";

function Sidebar(props) {
  const {
    routes,
    isUserLayout,
    subRoute,
    setOpenSidebar,
    openSubBar,
    setOpenSubBar,
    openSidebar,
    largeLogo,
    user,
    userRole,
  } = props;
  const isSidebarExpanded = openSubBar;

  let variantChange = "0.2s linear";
  let shadow = useColorModeValue(
    "4px 6px 12px 0 rgba(112, 144, 176, 0.06)", // lighter, softer
    "unset"
  );
  // Chakra Color Mode
  let sidebarBg = useColorModeValue("white", "navy.800");
  let sidebarMargins = "0px";

  return (
    <Box
      display={{ base: "none", xl: "flex" }}
      w="100%"
      position="fixed"
      minH="100%"
      className={`main-sidebar ${openSubBar ? "showlinkName" : "hideLinkName"}`}
      zIndex={1000}
    >
      <Box
        bg={sidebarBg}
        display="flex"
        w={isSidebarExpanded ? "280px" : "80px"}
        h="100vh"
        m={sidebarMargins}
        minH="100%"
        overflowX="hidden"
        overflowY="hidden"
        boxShadow={shadow}
        className={`left-sidebar1 overflow-visible ${openSubBar ? "showlinkName" : "hideLinkName"}`}
        transition="width 0.2s ease"
        borderRight="1px solid"
        borderRightColor="gray.100"
      >
        <Scrollbars
          autoHide
          renderTrackVertical={renderTrack}
          renderThumbVertical={renderThumb}
          renderView={renderView}
          className="custom-nav"
        >
          <Content
            key={`content-${user?._id || 'loading'}-${userRole || 'no-role'}`}
            isNavbarMenu={false}
            isUserLayout={isUserLayout}
            routes={routes}
            subRoute={subRoute}
            largeLogo={largeLogo}
            openSidebar={isSidebarExpanded}
            setOpenSidebar={setOpenSubBar}
            dynamic={false}
          />
        </Scrollbars>
      </Box>
    </Box>
  );
}

// FUNCTIONS
export function SidebarResponsive(props) {
  let sidebarBackgroundColor = useColorModeValue("white", "navy.800");
  let menuColor = useColorModeValue("gray.400", "white");
  // // SIDEBAR
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();
  const {
    routes,
    subRoute,
    openSubBar,
    setOpenSubBar,
    setOpenSidebar,
    isUserLayout,
    openSidebar,
    largeLogo,
    user,
    userRole,
  } = props;

  return (
    <Flex display={{ base: "flex", xl: "none" }} alignItems="center">
      <Flex
        ref={btnRef}
        w="max-content"
        h="max-content"
        onClick={() => {
          onOpen();
          setOpenSidebar(true);
        }}
      >
        <Icon
          as={IoMenuOutline}
          color={menuColor}
          my="auto"
          w="20px"
          h="20px"
          me="10px"
          _hover={{ cursor: "pointer" }}
        />
      </Flex>

      <Drawer
        isOpen={isOpen}
        onClose={() => {
          onClose();
        }}
        placement={document.documentElement.dir === "rtl" ? "right" : "left"}
        finalFocusRef={btnRef}
        size="xs"
      >
        <DrawerOverlay />
        <DrawerContent
          boxShadow={"xl"}
          w="285px"
          maxW="285px"
          bg={sidebarBackgroundColor}
        >
          <DrawerCloseButton
            zIndex="3"
            onClose={() => {
              onClose();
            }}
            _focus={{ boxShadow: "none" }}
            _hover={{ boxShadow: "none" }}
          />
          <DrawerBody maxW="285px" px="0rem" pb="0" pt={6}>
            <Box p={2} pt={4} h={'100%'}>
              <Content
                key={`mobile-content-${user?._id || 'loading'}-${userRole || 'no-role'}`}
                from={"modal"}
                isUserLayout={isUserLayout}
                isNavbarMenu={true}
                subRoute={subRoute}
                routes={routes}
                openSidebar={true} // Always open in mobile drawer
                setOpenSidebar={setOpenSidebar}
                largeLogo={largeLogo}
                dynamic={false}
              />
            </Box>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}
// PROPS

Sidebar.propTypes = {
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  variant: PropTypes.string,
};

export default Sidebar;
